import { Box, Text, VStack } from '@chakra-ui/react';
import { CampaignMonitorBody } from '../components/campaignMonitor/CampaignMonitorBody';
import { readCampaignMonitor } from '../components/campaignMonitor/model';

/** Operator-agent shell for a read-only campaign monitor card. No actions. */
export function CampaignMonitorCard({ payload }: { payload: unknown }) {
  const view = readCampaignMonitor(payload);
  return (
    <Box
      data-testid="campaign-monitor"
      data-card-kind="campaignMonitor"
      p={3}
      borderWidth="1px"
      borderColor="brand.border"
      borderRadius="md"
      bg="brand.surface"
      role="group"
      aria-label={`Campaign monitor: ${view.title}`}
    >
      <VStack align="flex-start" spacing={0} mb={2}>
        <Text fontSize="11px" color="brand.muted" textTransform="uppercase" letterSpacing="0.5px">Campaign monitor</Text>
        <Text fontSize="14px" fontWeight="700">{view.title}</Text>
      </VStack>
      <CampaignMonitorBody view={view} />
    </Box>
  );
}
